import type { CSSObject, Theme } from '@mui/material/styles';

function getOutlinedPrimaryHoverLayer(theme: Theme): CSSObject {
  const dark = theme.palette.primary.dark;
  const hoverSurface = theme.palette.common.white;
  return {
    [`--variant-outlinedColor`]: `${dark} !important`,
    [`--variant-outlinedBorder`]: `${dark} !important`,
    [`--variant-outlinedBg`]: `${hoverSurface} !important`,
    color: `${dark} !important`,
    backgroundColor: `${hoverSurface} !important`,
    borderColor: `${dark} !important`,
  };
}

/** Used by `MuiButton` `styleOverrides` for outlined + primary (WCAG 1.4.3). */
export function primaryOutlinedButtonAccessibleVars(theme: Theme): CSSObject {
  const dark = theme.palette.primary.dark;
  const borderSubtle = theme.alpha(dark, 0.5);
  const hoverOutlined = getOutlinedPrimaryHoverLayer(theme);
  return {
    [`--variant-outlinedColor`]: `${dark} !important`,
    [`--variant-outlinedBorder`]: `${borderSubtle} !important`,
    [`--variant-outlinedBg`]: 'transparent !important',
    color: `${dark} !important`,
    borderColor: `${borderSubtle} !important`,
    '&&:hover': hoverOutlined,
    '&:hover': hoverOutlined,
  };
}

/**
 * Merge into `sx` when a Button also sets `backgroundColor` (e.g. white on a footer); otherwise
 * MUI can leave hover at grey[100] + primary.main (~4.40:1).
 */
export function outlinedPrimaryButtonSxHover(theme: Theme): CSSObject {
  const hoverOutlined = getOutlinedPrimaryHoverLayer(theme);
  return {
    '&&:hover': hoverOutlined,
    '@media (hover: hover)': {
      '&&:hover': hoverOutlined,
    },
  };
}
